import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import DayPicker from '../DayPicker';
import './styles.css';

class IntlDatePicker extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatDate: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props, context) {
    super(props, context);

    const date = new Date();
    date.setDate(14);
    const months = [];
    for (let i = 0; i < 12; i += 1) {
      date.setMonth(i);
      months.push(this.props.intl.formatDate(date, { month: 'long' }));
    }

    const weekdaysShort = [];
    const weekdaysLong = [];
    date.setDate(date.getDate() - date.getDay());
    for (let i = 0; i < 7; i += 1) {
      weekdaysShort.push(this.props.intl.formatDate(date, { weekday: 'short' }));
      weekdaysLong.push(this.props.intl.formatDate(date, { weekday: 'long' }));
      date.setDate(date.getDate() + 1);
    }

    this.state = { months, weekdaysShort, weekdaysLong };
  }

  getFirstDayOfWeek = (locale) => 0;

  getMonths = (locale) => this.state.months;

  formatDay = (d, locale = 'en') => this.props.intl.formatDate(d, { day: 'numeric', month: 'long', year: 'numeric' });

  formatMonthTitle = (d, locale) => this.props.intl.formatDate(d, { month: 'long', year: 'numeric' });

  formatWeekdayShort = (index, locale = 'en') => this.state.weekdaysShort[index];

  formatWeekdayLong = (index, locale = 'en') => this.state.weekdaysLong[index];

  render() {
    return (
      <DayPicker className="day-picker" localeUtils={this} styleName="day-picker" {...this.props} />
    );
  }
}

export default injectIntl(IntlDatePicker);
